export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10447.6be4b9c4.jpg";